import { createReducer, FAILURE, REQUEST, SUCCESS, updateObject } from 'Stores'
import {
  CREATE_PORTFOLIO,
  DELETE_MEMBER_PORTFOLIO,
  DELETE_PORTFOLIO_BY_ID,
  GET_ALL_CUSTOMER,
  GET_ALL_MEMBER_IN_PORTFOLIO,
  GET_ALL_ROLES_PERMISSION,
  GET_ASSET_GOALS,
  GET_GROWTH_SCHEDULES,
  GET_PORTFOLIO_BY_ID, GET_PORTFOLIO_BY_ID_EDIT,
  GET_PORTFOLIO_BY_USERID, GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD, GET_VERIFY_INVITE_MEMBER_PORTFOLIO,
  POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO,
  POST_INVITE_MEMBER_PORTFOLIO,
  SET_EMPTY_PORTFOLIO_BY_ID,
  UPDATE_ASSET_GOALS,
  UPDATE_GROWTH_SCHEDULES, UPDATE_PORTFOLIO_NAME,
  UPDATE_TIME_IPO
} from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  success: false,
  isSubmitted: false,
  customerList: null,
  listPortFolioByUserId: [],
  portFolioById: null,
  portFolioByIdInChangeName: null,
  assetGoalsData: null,
  updateTimeIPOStatus: false,
  growthSchedulesData: null,
  updateAssetGoalsSuccess: false,
  updateGrowthSchedulesSuccess: false,
  listMemberInPortfolio: null,
  listRoles: null,
  userInvite: null
}

function createPortFolio(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function createPortFolioSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    isSubmitted: true,
    success: SUCCESS(CREATE_PORTFOLIO)
  })
}

function createPortFolioError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getAllCustomer(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getAllCustomerSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    customerList: payload
  })
}

function getAllCustomerError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getPortFolioById(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getPortFolioByIdSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    portFolioById: payload
  })
}

function getPortFolioByIdError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function deletePortFolioById(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function deletePortFolioByIdSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(DELETE_PORTFOLIO_BY_ID)
  })
}

function deletePortFolioByIdError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getPortFolioListByUserId(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getPortFolioListByUserIdSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    listPortFolioByUserId: payload
  })
}

function getPortFolioListByUserIdError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getPortFolioListByUserIdWithAction(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getPortFolioListByUserIdWithActionSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    listPortFolioByUserId: payload
  })
}

function getPortFolioListByUserIdWithActionError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function updateTimeIPO(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function updateTimeIPOSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    updateTimeIPOStatus: true
  })
}

function updateTimeIPOError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getAssetGoals(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getAssetGoalsSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    assetGoalsData: payload
  })
}

function getAssetGoalsError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getGrowthSchedules(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getGrowthSchedulesSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: true,
    growthSchedulesData: payload
  })
}

function getGrowthSchedulesError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function updateAnnualAssetGoals(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function updateAnnualAssetGoalsSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(UPDATE_ASSET_GOALS)
  })
}

function updateAnnualAssetGoalsError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function updateGrowthSchedules(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function updateGrowthSchedulesSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(UPDATE_GROWTH_SCHEDULES)
  })
}

function updateGrowthSchedulesError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getPermissionRoles(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getPermissionRolesSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    listRoles: payload
  })
}

function getPermissionRolesError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getAllMemberInPortFolio(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getAllMemberInPortFolioSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(GET_ALL_MEMBER_IN_PORTFOLIO),
    listMemberInPortfolio: payload
  })
}

function getAllMemberInPortFolioError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function postInviteMemberPortFolio(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function postInviteMemberPortFolioSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(POST_INVITE_MEMBER_PORTFOLIO)
  })
}

function postInviteMemberPortFolioError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function postVerifyInviteMemberPortFolio(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function postVerifyInviteMemberPortFolioSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(GET_VERIFY_INVITE_MEMBER_PORTFOLIO),
    userInvite: payload
  })
}

function postVerifyInviteMemberPortFolioError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function postAcceptedInviteMemberPortFolio(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function postAcceptedInviteMemberPortFolioSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO)
  })
}

function postAcceptedInviteMemberPortFolioError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function deletePortfolioMember(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function deletePortfolioMemberSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(DELETE_MEMBER_PORTFOLIO)
  })
}

function deletePortfolioMemberError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function updatePortfolioName(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function updatePortfolioNameSuccess(state) {
  return updateObject(state, {
    isLoading: false,
    success: SUCCESS(UPDATE_PORTFOLIO_NAME)
  })
}

function updatePortfolioNameError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getPortFolioByIdEdited(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getPortFolioByIdEditedSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    portfolioSelected: payload,
    success: SUCCESS(GET_PORTFOLIO_BY_ID_EDIT)
  })
}

function getPortFolioByIdEditedError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function setEmptyPortfolioById(state) {
  return updateObject(state, {
    isLoading: false,
    portFolioById: null
  })
}

// Slice reducer
export default createReducer(initialState, {
  [REQUEST(CREATE_PORTFOLIO)]: createPortFolio,
  [SUCCESS(CREATE_PORTFOLIO)]: createPortFolioSuccess,
  [FAILURE(CREATE_PORTFOLIO)]: createPortFolioError,

  [REQUEST(GET_ALL_CUSTOMER)]: getAllCustomer,
  [SUCCESS(GET_ALL_CUSTOMER)]: getAllCustomerSuccess,
  [FAILURE(GET_ALL_CUSTOMER)]: getAllCustomerError,

  [REQUEST(GET_PORTFOLIO_BY_USERID)]: getPortFolioListByUserId,
  [SUCCESS(GET_PORTFOLIO_BY_USERID)]: getPortFolioListByUserIdSuccess,
  [FAILURE(GET_PORTFOLIO_BY_USERID)]: getPortFolioListByUserIdError,

  [REQUEST(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD)]: getPortFolioListByUserIdWithAction,
  [SUCCESS(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD)]: getPortFolioListByUserIdWithActionSuccess,
  [FAILURE(GET_PORTFOLIO_BY_USERID_AFTER_ACTION_CRUD)]: getPortFolioListByUserIdWithActionError,

  [REQUEST(UPDATE_TIME_IPO)]: updateTimeIPO,
  [SUCCESS(UPDATE_TIME_IPO)]: updateTimeIPOSuccess,
  [FAILURE(UPDATE_TIME_IPO)]: updateTimeIPOError,

  [REQUEST(GET_PORTFOLIO_BY_ID)]: getPortFolioById,
  [SUCCESS(GET_PORTFOLIO_BY_ID)]: getPortFolioByIdSuccess,
  [FAILURE(GET_PORTFOLIO_BY_ID)]: getPortFolioByIdError,

  [REQUEST(DELETE_PORTFOLIO_BY_ID)]: deletePortFolioById,
  [SUCCESS(DELETE_PORTFOLIO_BY_ID)]: deletePortFolioByIdSuccess,
  [FAILURE(DELETE_PORTFOLIO_BY_ID)]: deletePortFolioByIdError,

  [REQUEST(GET_ASSET_GOALS)]: getAssetGoals,
  [SUCCESS(GET_ASSET_GOALS)]: getAssetGoalsSuccess,
  [FAILURE(GET_ASSET_GOALS)]: getAssetGoalsError,

  [REQUEST(GET_GROWTH_SCHEDULES)]: getGrowthSchedules,
  [SUCCESS(GET_GROWTH_SCHEDULES)]: getGrowthSchedulesSuccess,
  [FAILURE(GET_GROWTH_SCHEDULES)]: getGrowthSchedulesError,

  [REQUEST(UPDATE_ASSET_GOALS)]: updateAnnualAssetGoals,
  [SUCCESS(UPDATE_ASSET_GOALS)]: updateAnnualAssetGoalsSuccess,
  [FAILURE(UPDATE_ASSET_GOALS)]: updateAnnualAssetGoalsError,

  [REQUEST(UPDATE_GROWTH_SCHEDULES)]: updateGrowthSchedules,
  [SUCCESS(UPDATE_GROWTH_SCHEDULES)]: updateGrowthSchedulesSuccess,
  [FAILURE(UPDATE_GROWTH_SCHEDULES)]: updateGrowthSchedulesError,

  [REQUEST(GET_ALL_ROLES_PERMISSION)]: getPermissionRoles,
  [SUCCESS(GET_ALL_ROLES_PERMISSION)]: getPermissionRolesSuccess,
  [FAILURE(GET_ALL_ROLES_PERMISSION)]: getPermissionRolesError,

  [REQUEST(GET_ALL_MEMBER_IN_PORTFOLIO)]: getAllMemberInPortFolio,
  [SUCCESS(GET_ALL_MEMBER_IN_PORTFOLIO)]: getAllMemberInPortFolioSuccess,
  [FAILURE(GET_ALL_MEMBER_IN_PORTFOLIO)]: getAllMemberInPortFolioError,

  [REQUEST(POST_INVITE_MEMBER_PORTFOLIO)]: postInviteMemberPortFolio,
  [SUCCESS(POST_INVITE_MEMBER_PORTFOLIO)]: postInviteMemberPortFolioSuccess,
  [FAILURE(POST_INVITE_MEMBER_PORTFOLIO)]: postInviteMemberPortFolioError,

  [REQUEST(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO)]: postAcceptedInviteMemberPortFolio,
  [SUCCESS(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO)]: postAcceptedInviteMemberPortFolioSuccess,
  [FAILURE(POST_ACCEPTED_INVITE_MEMBER_PORTFOLIO)]: postAcceptedInviteMemberPortFolioError,

  [REQUEST(GET_VERIFY_INVITE_MEMBER_PORTFOLIO)]: postVerifyInviteMemberPortFolio,
  [SUCCESS(GET_VERIFY_INVITE_MEMBER_PORTFOLIO)]: postVerifyInviteMemberPortFolioSuccess,
  [FAILURE(GET_VERIFY_INVITE_MEMBER_PORTFOLIO)]: postVerifyInviteMemberPortFolioError,

  [REQUEST(DELETE_MEMBER_PORTFOLIO)]: deletePortfolioMember,
  [SUCCESS(DELETE_MEMBER_PORTFOLIO)]: deletePortfolioMemberSuccess,
  [FAILURE(DELETE_MEMBER_PORTFOLIO)]: deletePortfolioMemberError,

  [REQUEST(UPDATE_PORTFOLIO_NAME)]: updatePortfolioName,
  [SUCCESS(UPDATE_PORTFOLIO_NAME)]: updatePortfolioNameSuccess,
  [FAILURE(UPDATE_PORTFOLIO_NAME)]: updatePortfolioNameError,

  [REQUEST(GET_PORTFOLIO_BY_ID_EDIT)]: getPortFolioByIdEdited,
  [SUCCESS(GET_PORTFOLIO_BY_ID_EDIT)]: getPortFolioByIdEditedSuccess,
  [FAILURE(GET_PORTFOLIO_BY_ID_EDIT)]: getPortFolioByIdEditedError,

  [REQUEST(SET_EMPTY_PORTFOLIO_BY_ID)]: setEmptyPortfolioById
})
